import { render, staticRenderFns } from "./ManageSidePanel.vue?vue&type=template&id=27227a22&"
import script from "./ManageSidePanel.vue?vue&type=script&lang=js&"
export * from "./ManageSidePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27227a22')) {
      api.createRecord('27227a22', component.options)
    } else {
      api.reload('27227a22', component.options)
    }
    module.hot.accept("./ManageSidePanel.vue?vue&type=template&id=27227a22&", function () {
      api.rerender('27227a22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/manage-side-panel/ManageSidePanel.vue"
export default component.exports